import $ from 'jquery';

// const pageBg = () => {
//   const pageBgEelem = $('.js-page-bg');

//   if (!pageBgEelem.length) {
//     return;
//   }

//   const initPos = parseInt(pageBgEelem.css('top'), 10);
//   let scroll = 0;
//   let position = $(window).scrollTop();

//   $(window).on('scroll', () => {
//     const scrollingPosition = $(window).scrollTop();
//     const scrollingDirection = scrollingPosition > position ? 'down' : 'up';

//     if (scrollingDirection === 'down') {
//       scroll += 0.2;
//       pageBgEelem.css({ top: initPos - scroll });
//     } else {
//       scroll -= 0.2;
//       pageBgEelem.css({ top: initPos + scroll });
//     }

//     position = scrollingPosition;
//   });
// };

class PageBgParallax {
  constructor() {
    this.pageBg = $('.js-page-bg');

    if (!this.pageBg.length || !this.pageBg.hasClass('is-parallax')) {
      return;
    }

    this.multiplier = 1 - 0.5;
    this.document = $(document);

    this.pageBg.css({ 'background-attatchment': 'fixed' });

    $(window).on('scroll', () => {
      const fromTop = this.document.scrollTop();
      const bgCss = `0px -${this.multiplier * fromTop}px`;

      this.pageBg.css({ 'background-position': bgCss });
    });
  }
}

export default new PageBgParallax();



// WEBPACK FOOTER //
// ./src/scripts/modules/page-bg-parallax.js